import { CONTAINER_SPACING_PX, type SpacingToken } from '../lib/spacing';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type ContainerProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
  spacing?: {
    bottom?: SpacingToken;
    top?: SpacingToken;
  };
}>;

export function Container({ props }: ContainerProps) {
  return (
    <div
      style={{
        marginTop: CONTAINER_SPACING_PX[props.spacing?.top ?? '0'],
        marginBottom: CONTAINER_SPACING_PX[props.spacing?.bottom ?? '0'],
      }}
    >
      <StructuredContentRenderer doc={props.children} />
    </div>
  );
}
